import React from "react";
import "./content.css";
import ghosts from "../../../src/assets/images/home-page/Ghosts.png";
import boy from "../../../src/assets/images/home-page/boy.png";
import clickButton from "../../../src/assets/images/home-page/clickButton.png";
    import friends from "../../../src/assets/images/home-page/Friends.png";
import loveEmoji from "../../../src/assets/images/home-page/Love - Cartoon.png";
import smileEmoji from "../../../src/assets/images/home-page/Heavy Smile - Cartoon.png";
import speechBubble from "../../../src/assets/images/home-page/Speech Bubble - Right.png";
import child from "../../../src/assets/images/home-page/child.png";
import arrowRight from "../../../src/assets/images/home-page/arrowRight.png";
import arrowLeft from "../../../src/assets/images/home-page/arrowLeft.png";
import { useTranslation } from "react-i18next";

const Content = () => {
  const [t, i18n] = useTranslation();
    return (
        <div className="content container">
            <section className="section1">
                <div className="content-ghosts">
                    <img src={ghosts} alt=""/>
                </div>
                <img src={boy} alt="" className="content-boy"/>
                <div>
                    <img src={clickButton} alt="" className="content-clickbutton"/>
                </div>
            </section>
            <section className="section2">
                <div className="section2-top">
                    <img src={friends} alt="" className="content-friends" />
                    <h1>{t('content-opnion.heading')}</h1>
                </div>
                <div className="section2-middle">
                    <div className="content-opinion">
                        <div className="content-stickers">
                            <img src={loveEmoji} alt="" className="content-loveEmoji" />
                            <img src={smileEmoji} alt="" className="content-smileEmoji" />
                            <img src={speechBubble} alt="" className="content-speechBubble" />
                        </div>
                        <div className="content-info">
                            <img src={child} alt="" className="content-child" />
                            <h3>احمد سمير</h3>
                            <p>الأكاديمية الاكبر والاعظم في الوطن العربي مفيش كلام يقدر يوصفكم، دايما في الامام انشاء الله.. شكرا</p>
                        </div>
                        <div className="content-arrows">
                            <img src={arrowLeft} alt="" className="content-arrow" />
                            <img src={arrowRight} alt="" className="content-arrow-right" />
                        </div>
                    </div>
                </div>
            </section>
            </div>
    )

};
export default Content;
